<template>
  <div class="footer" :style="[footStyleHeight, footerLineHeight, headFooterStyle]">
    <slot>
      <!-- Copyright 2005-2025 技术架构：甲骨文超级码科技股份 版权所有 Inc.All Reserved. 浙ICP备05049758号 -->
      <div :style="signature1Style1">{{individuationSetting.signature1}}</div>
      <div :style="signature1Style2" v-if="individuationSetting.signature2">{{individuationSetting.signature2}}</div>
    </slot>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    computed: {
      footerLineHeight(){
        return {lineHeight: (this.individuationSetting.signature2 || this.individuationSetting.signature3) ? '1em' : '60px'}
      },
      footStyleHeight(){
        const height = this.$store.state.contentMarginBottom;
        return {height: height + 'px', lineHeight: height + 'px'}
      },
      signature1Style1(){
        return {margin: (this.individuationSetting.signature2 || this.individuationSetting.signature3) ? '12px auto 8px' : ''}
      },
      signature1Style2(){
        return {margin: (this.individuationSetting.signature1 || this.individuationSetting.signature3) ? '4px auto 0' : ''}
      },
      ...mapState({individuationSetting: 'individuationSetting', headFooterStyle: 'headFooterStyle'})
    },
    props: {
      bgColor: {
        type: String,
        default: ''
      },
      fontColor: {}
    }
  }
</script>
<style lang='less'>
  @import '../../assets/less/base.less';
  .footer{
    position:absolute;
    left:0;
    right: 0;
    bottom:0;
    height: @footer-height;
    line-height: @footer-height;
    text-align:center;
    color:lighten(@font-color-normal,20%);
    font-size: 14px;
    z-index: 10;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// footer.vue?52daad44